const lang = 'en-GB';
export const createSuccessResponse = (response, meta, arg) => {
    return {
        // message: { status: meta.response.status, message: response.message },
        message: response.message,
        status: meta.response.status,
        success: response.success,
        name: arg.name,
        finished: new Date(Date.now()).toLocaleString(lang),
    };
};

export const createErrorResponse = (response, meta, arg, defaultErrorMsg) => {
    // const message = {};
    let message;
    let status;
    switch (response.status) {
        case 400:
        case 406: {
            const data = JSON.parse(response.data);
            // message['status'] = response.status;
            // message['message'] = (data && data.message) || `HTTP Error ${response.status}`;
            status = response.status;
            message = (data && data.message) || `HTTP Error ${response.status}`;
            break;
        }
        default:
            status = response.status;
            message = defaultErrorMsg;
        // message['status'] = response.status;
        // message['message'] = defaultErrorMsg;
    }
    return {
        message,
        status,
        success: false,
        name: arg.name,
        finished: new Date(Date.now()).toLocaleString(lang),
    };
};
